import { uniqBy } from 'lodash';


export class DashboardService {

    /**
     * @returns {Driver}
     * @param {Job[]} activeJobs 
     */
    getDriversFromActiveJobs(activeJobs) {
        const driversData = [];

        activeJobs?.forEach(job => {
            const driver = {
                name: job.driverDetail?.driverName,
                lat: job.driverDetail?.latitude,
                lng: job.driverDetail?.longitude,
                id: job.driverNumber
            };

            let valid;
            if ((job.deliveryDistance || job.pickupDistance) && !(job.deliveryDistance && job.pickupDistance)) {
                valid = true;
            } else {
                valid = false;
            }

            const found = driversData.find(({ id }) => id === driver.id);

            // Perm vehicle override
            if (job.deliverySuburb.trim() === 'VARIOUS') {
                valid = true;
            }

            driversData.push(driver);
        })

        return uniqBy(driversData, 'id');
    }
    
}